var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(item){return _c('div',{key:item.family_phone_id},[_c('div',{attrs:{"title":'id: ' +
          item.family_phone_id +
          '\ncreated: ' +
          item.created_at +
          '\nmodified: ' +
          item.modified_at}},[_vm._v(" "+_vm._s(item.number)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }